(function () {
  const initSlider = (section) => {
    if (!section || !section.classList.contains("image-ticker-section")) return;

    const sliderEl = section.querySelector(".image-ticker-slider");
    if (!sliderEl) return;

    const speed = Number(sliderEl.dataset.sliderSpeed || 8) * 1000;
    const slidesPerView = Number(sliderEl.dataset.slidesPerView || 5);
    const isReverseDirection =
      sliderEl.dataset.reverseDirection === "true" ? true : false;

    new Swiper(sliderEl, {
      loop: true,
      allowTouchMove: false,
      spaceBetween: 8,
      speed: speed,
      slidesPerView: slidesPerView,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: isReverseDirection,
      },
      breakpoints: {
        750: {
          spaceBetween: 12,
        },
      },
    });
  };

  initSlider(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", function (event) {
    initSlider(event.target);
  });
})();
